import React, {
  forwardRef,
  ReactNode,
  RefObject,
  useEffect,
  useState,
} from 'react'

interface IProps {
  resultVisible?: boolean
  toggleLabel: string
  children: ReactNode
  rf?: string
  onChangeVisibility?: (visible: boolean) => void
}

const FullResultContainer = forwardRef(
  (
    { resultVisible, toggleLabel, children, rf, onChangeVisibility }: IProps,
    ref?: RefObject<HTMLDivElement>,
  ) => {
    const [showDetailTable, setShowDetailTable] = useState(resultVisible)

    useEffect(() => {
      if (
        resultVisible !== undefined &&
        resultVisible !== null &&
        showDetailTable !== resultVisible
      ) {
        setShowDetailTable(resultVisible)
      }
    }, [resultVisible])

    const handleShowDetailTable = () => {
      const isVisible = !showDetailTable
      if (onChangeVisibility) {
        onChangeVisibility(isVisible)
      }
      setShowDetailTable(isVisible)
    }

    return (
      <div className='csas-calc-loan-way-out csas-pb-xs csas-pt-xs' ref={ref}>
        <div className='csas-mb-md csas-center'>
          <a
            className='csas-switch csas-underline'
            data-rf={rf}
            onClick={handleShowDetailTable}
          >
            {toggleLabel}
          </a>
        </div>
        {showDetailTable && children}
      </div>
    )
  },
)

export default FullResultContainer
